import { connectHook } from 'app/common/components/connect-hook';
import { SettingsNav } from './settings-nav.js';
import { useSettingsNav } from './settings-nav-hook.js';

export default connectHook(SettingsNav, useSettingsNav);
